import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import type { ChildRouteContext } from "@/root";

import UpdateRequestByUuid from "@/modules/application/user/components/UpdateRequestByUuid";
import {
  GuestRequestError,
  GuestRequestPending,
} from "@/modules/application/user/components/application/GuestRequestStates";
import { fetchApplicationRequestFlowByUuidQueryOptions } from "@/modules/application/user/services";

export const Route = createFileRoute("/application/requests/uuid/$uuid")({
  component: Component,
  parseParams: (params) => ({
    uuid: z.string().uuid().parse(params.uuid),
  }),
  stringifyParams: ({ uuid }) => ({ uuid }),
  beforeLoad: ({ context }) => {
    return {
      title: () => context.t("Workflow", { ns: "application.shared" }),
    } satisfies ChildRouteContext;
  },
  loader: (opts) =>
    opts.context.queryClient.ensureQueryData(
      fetchApplicationRequestFlowByUuidQueryOptions(opts.params.uuid),
    ),
  pendingComponent: GuestRequestPending,
  errorComponent: ({ error }) => <GuestRequestError error={error} />,
});

function Component() {
  const { uuid } = Route.useParams();

  return <UpdateRequestByUuid uuid={uuid} />;
}
